export const SERVER_API_URL = process.env.REACT_APP_SERVER_API_URL || '';
// export const SERVER_API_URL = 'http://localhost:8080' || '';
export const APP_CODE = 'datm-client';
